const ToolTag = (props) => {
  return (
    <div className="tool-tag text-R-medium">
      {props.children}
      <div className="tool-tag__filler-drop"></div>
    </div>
  );
};

export default ToolTag;
